var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"close",attrs:{"role":"button"}},[_c('span',{staticClass:"tip"},[_vm._v("削除")]),_c('IcFalse')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }